var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "lpu-rating bg-gray-40 rounded-30",
      class: {
        "lpu-rating--mobile pa-4": _setup.isMobile,
        "pa-8": !_setup.isMobile,
        "lpu-rating--expandable": _setup.canExpand,
      },
      attrs: {
        id: "rating",
        "data-qa": "lpu_rating",
        role: _setup.canExpand ? "button" : undefined,
        tabindex: _setup.canExpand ? 0 : undefined,
        "aria-expanded": _setup.canExpand
          ? _setup.isExpanded
            ? "true"
            : "false"
          : undefined,
      },
      on: {
        click: _setup.onBlockClick,
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _setup.onBlockClick.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            )
              return null
            $event.preventDefault()
            return _setup.onBlockClick.apply(null, arguments)
          },
        ],
      },
    },
    [
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c(
          "div",
          {
            staticClass: "d-flex flex-column",
            class: _setup.isMobile ? "ga-5" : "ga-3",
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex align-center",
                class: _setup.isMobile ? "ga-3" : "lpu-rating__title-row",
              },
              [
                _c(
                  "h2",
                  {
                    staticClass: "text--text",
                    class: _setup.isMobile ? "text-h6" : "text-h5",
                    attrs: { "data-qa": "lpu_rating_title" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.tStatic("Рейтинг")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _setup.canExpand
                  ? _c(
                      "div",
                      {
                        staticClass: "lpu-rating__toggle flex-shrink-0",
                        attrs: {
                          "data-qa": "lpu_rating_toggle",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("span", {
                          staticClass:
                            "lpu-rating__toggle-icon ui-icon-arrow-down ui-icon-fz-big",
                          class: [
                            {
                              "lpu-rating__toggle-icon--expanded":
                                _setup.isExpanded,
                            },
                            _setup.ff_lpu_branding_page_v5
                              ? "text-lpu-branding-color-text"
                              : "text-lpu-branding-color-primary",
                          ],
                        }),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _setup.isMobile
                  ? "d-flex flex-column ga-6"
                  : "d-flex align-end ga-6",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-shrink-0",
                    class: _setup.isMobile
                      ? "d-flex align-start ga-3"
                      : "d-flex flex-column ga-3",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "text--text font-weight-bold",
                        class: _setup.isMobile
                          ? "lpu-rating__total-score--mobile"
                          : "lpu-rating__total-score--desktop",
                        attrs: { "data-qa": "lpu_rating_total_score" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_setup.totalScoreText) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "lpu-rating__stars-card bg-gray-0 rounded-10 d-inline-flex align-center px-4 py-2",
                      },
                      [
                        _c(_setup.StarsRate, {
                          attrs: {
                            "data-qa": "lpu_rating_stars",
                            solidity: _vm.lpu.stars ?? 0,
                            color: _setup.hasFraudMark ? "grey" : undefined,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex-grow-1 min-w-0",
                    class: _setup.isMobile
                      ? "d-flex flex-column ga-4"
                      : "lpu-rating__categories",
                  },
                  [
                    _c(_setup.RatingCategoryCard, {
                      staticClass: "flex-grow-1",
                      attrs: {
                        title: _setup.tStatic("Клиника"),
                        score: _setup.clinicCategory.score,
                        "has-score": _setup.clinicCategory.hasScore,
                        "icon-src": _setup.CLINIC_ICON_SRC,
                      },
                    }),
                    _vm._v(" "),
                    _setup.showDoctorsRating
                      ? _c(_setup.RatingCategoryCard, {
                          staticClass: "flex-grow-1",
                          attrs: {
                            title: _setup.tStatic("Врачи"),
                            score: _setup.doctorsCategory.score,
                            "has-score": _setup.doctorsCategory.hasScore,
                            "icon-src": _setup.DOCTORS_ICON_SRC,
                          },
                        })
                      : !_setup.isMobile
                      ? _c("div", {
                          staticClass: "flex-grow-1",
                          attrs: { "aria-hidden": "true" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _setup.hasFraudMark
          ? _c(
              "div",
              {
                staticClass: "d-flex align-center",
                class: _setup.isMobile ? "mt-5" : "mt-6",
                attrs: { "data-qa": "lpu_rating_fraud_mark" },
              },
              [
                _c("div", {
                  staticClass:
                    "ui-icon-circle-info text-error--text mr-2 flex-shrink-0",
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-2 text-error--text" }, [
                  _vm._v(
                    "\n        " + _vm._s(_setup.fraudMarkText) + "\n      "
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.canExpand
          ? _c(
              "div",
              {
                staticClass: "lpu-rating__details-expand",
                class: {
                  "lpu-rating__details-expand--open": _setup.isExpanded,
                },
                attrs: {
                  "data-qa": "lpu_rating_details",
                  "aria-hidden": _setup.isExpanded ? "false" : "true",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "lpu-rating__details-expand-inner" }, [
                  _c(
                    "div",
                    {
                      class: _setup.isMobile
                        ? "d-flex flex-column ga-4 pt-5"
                        : "lpu-rating__details--desktop pt-6",
                    },
                    [
                      _setup.isMobile
                        ? _vm._l(_setup.mobileStats, function (stat) {
                            return _c(_setup.RatingStatItem, {
                              key: stat.key,
                              attrs: {
                                title: stat.title,
                                value: stat.value,
                                "is-large-scale": stat.isLargeScale,
                                "has-fraud-mark": _setup.hasFraudMark,
                              },
                            })
                          })
                        : [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column ga-5" },
                              _vm._l(
                                _setup.visibleClinicStats,
                                function (stat) {
                                  return _c(_setup.RatingStatItem, {
                                    key: stat.key,
                                    attrs: {
                                      title: stat.title,
                                      value: stat.value,
                                      "is-large-scale": stat.isLargeScale,
                                      "has-fraud-mark": _setup.hasFraudMark,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                            _vm._v(" "),
                            _setup.showDoctorsRating
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex flex-column ga-5" },
                                  _vm._l(
                                    _setup.visibleDoctorsStats,
                                    function (stat) {
                                      return _c(_setup.RatingStatItem, {
                                        key: stat.key,
                                        attrs: {
                                          title: stat.title,
                                          value: stat.value,
                                          "is-large-scale": stat.isLargeScale,
                                          "has-fraud-mark": _setup.hasFraudMark,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              : _c("div", { attrs: { "aria-hidden": "true" } }),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }